import TsaCompanyRealNameInfoVerify from '@/components/companyRealNameInfoVerify/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const CompanyRealNameInfoVerify = vue.extend(TsaCompanyRealNameInfoVerify)
    if (!$vm) {
      $vm = new CompanyRealNameInfoVerify({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const companyRealNameInfoVerify = {
      show (options = {}) {
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
        $vm.init()
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaCompanyRealNameInfoVerify) {
      vue.prototype.$TsaCompanyRealNameInfoVerify = companyRealNameInfoVerify
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/companyRealNameInfoVerify/index.js